export default "__VITE_ASSET__dGdPL7YB__"